module.exports = __webpack_public_path__ + "static/img/IL.560730d4.jpg";